import { BREAKPOINTS, getImageSizes, ImageSource, ImageSourceSizes } from '@ag1/ui';
import { useMemo } from 'react';
import clsx from 'clsx';
import { ResponsiveContentBlockImageType } from '../types';
import { getResponsiveSanityImage } from '../utils';
import { ImagePlaceholder } from './ImagePlaceholder';
import styles from '../../styles.module.scss';

export const ResponsiveContentBlockImage: React.FC<{
  image: ResponsiveContentBlockImageType | null | undefined;
  className?: string;
  sizes?: ImageSourceSizes;
  eagerLoading?: boolean;
}> = ({ image, className, sizes: originalSizes, eagerLoading = false }) => {
  const { desktop, mobile } = useMemo(() => getResponsiveSanityImage(image), [image]);
  const sizes = getImageSizes(originalSizes);

  return !desktop && !mobile ? (
    <ImagePlaceholder />
  ) : (
    <picture>
      {desktop && (
        <ImageSource
          {...desktop}
          media={mobile ? `(min-width:${BREAKPOINTS.s}px)` : ''}
          sizes={sizes}
        />
      )}
      {mobile && <ImageSource {...mobile} sizes={sizes} />}
      <img
        className={clsx(styles.image, className)}
        loading={eagerLoading ? 'eager' : 'lazy'}
        alt=""
        fetchPriority={eagerLoading ? 'high' : undefined}
      />
    </picture>
  );
};
